import { FC } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useIsAdmin } from "../../../auth/useIsAdmin";

export const AdminMenu: FC = () => {
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return null;
  }

  return (
    <Box display="flex" width="100%" alignItems="center">
      <IconButton
        onClick={() => navigate("/home")}
        sx={{ color: "secondary.main" }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ ml: 1 }}>
        Admin
      </Typography>
    </Box>
  );
};
